import { formAddressToCustomerAdapter } from 'shared/lib';

import type { TCreditFormCommonFields } from 'entities/creditForm';

export class Addresses {
  constructor(
    private readonly data: Pick<
      Partial<TCreditFormCommonFields>,
      | 'registrationAddress'
      | 'registrationAddressFlat'
      | 'registrationDate'
      | 'residenceAddress'
      | 'residenceAddressFlat'
      | 'residenceAddressIsRegistration'
      | 'registrationLocationRoute'
      | 'residenceLocationRoute'
    >,
    // eslint-disable-next-line no-empty-function
  ) {}

  profile() {
    return {
      registrationAddress: formAddressToCustomerAdapter(this.data.registrationAddress, {
        flat: this.data.registrationAddressFlat,
        locationRoute: this.data.registrationLocationRoute,
      }),
      registrationAddressFlat: this.data.registrationAddressFlat || undefined,
      registrationDate: this.data.registrationDate,
      residenceAddress: formAddressToCustomerAdapter(this.data.residenceAddress, {
        flat: this.data.residenceAddressFlat,
        locationRoute: this.data.residenceLocationRoute,
      }),
      residenceAddressFlat: this.data.residenceAddressFlat || undefined,
      residenceAddressIsRegistration: this.data.residenceAddressIsRegistration,
    };
  }

  loans() {
    const { registrationDate, ...rest } = this.profile();

    return {
      registrationDate: registrationDate || '',
      ...rest,
    };
  }
}
